import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // AOS stil dosyasını import ediyoruz

import './Carousel.css';
import { about, why1, why2, why3, why4, why5, why6, why7, why8, why9 } from "../../../assets/images/index";
import { useTranslation } from "react-i18next";


const opportunitiesData = [
  { id: 1, image: why1, title: "Təcrübəli Mütəxəssislər", description: "Dünyaca tanınmış həkimlər və yüksək ixtisaslı tibbi personal ilə xidmət göstəririk." },
  { id: 2, image: why2, title: "Müasir Təchizat", description: "Ən son texnologiya ilə təchiz edilmiş klinikalar və xəstəxanalar." },
  { id: 3, image: why3, title: "Fərdi Yanaşma", description: "Hər bir xəstəyə xüsusi müalicə planı və dəstək." },
  { id: 4, image: why4, title: "Şəffaf Qiymətlər", description: "Müalicə və xidmətlərin tamamilə aydın qiymət siyahısı." },
  { id: 5, image: why5, title: "Beynəlxalq Keyfiyyət", description: "Qlobal standartlara uyğun tibbi xidmət və təhlükəsizlik." },
  { id: 6, image: why6, title: "Tam Dəstək Xidməti", description: "Gəlişdən dönüşə qədər bütün səyahət və müalicə tənzimləmələri." },
  { id: 7, image: why7, title: "Premium Xidmətlər", description: "Tibbi xidmətlərdən əlavə, rahat səyahət və qalma imkanları təqdim edirik." },
  { id: 8, image: why8, title: "Sanatoriya Xidmətlər", description: "Sağlamlıq turizmi üçün unikal sanatoriyalar və reabilitasiya mərkəzləri." },
  { id: 9, image: why9, title: "Etibarlı Tərəfdaşınız", description: "Etibar və peşəkarlıqla həm müalicə, həm də güvən qazanın." }
];

const Opportunities = () => {

    const { t, i18n } = useTranslation();
  // AOS'u başlatıyoruz
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animasyon süresi (ms)
      once: true, // Sadece bir kere animasyonu tetikle
    });
  }, []);

  return (
    <div className="max-w-containerSm md:max-w-container mx-auto mt-[64px] md:mt-[104px]">
      <div className="flex items-center justify-between">
        <p className="md:text-[46px] text-3xl font-medium">{t("Niyə biz ?")}</p>
        <a href='/why-us'>
          <button className='h-[51px] w-[164px] rounded-[12px] bg-[#FB8C00] text-white md:block hidden'>{t("Hamısına bax")}</button>
        </a>
      </div>
      <div className="grid md:grid-cols-3 mt-10 gap-10">
        {opportunitiesData.map((item) => (
          <div key={item.id} className="border-[1px] border-[#388E3C] rounded-[20px]" data-aos="fade-up">
            <img className="h-[194px] w-full rounded-t-[20px]" src={item.image} alt="Opportunity" />
            <div className="px-5">
              <p className="mt-[20px] text-2xl md:text-[24px] font-medium">{t(item.title)}</p>
              <p className="mt-[12px] mb-[20px]">{t(item.description)}</p>
            </div>
          </div>
        ))}
      </div>
      <a href='/why-us'>
        <button className='h-[51px] w-full rounded-[12px] bg-[#FB8C00] text-white md:hidden block mt-8'>{t("Hamısına bax")}</button>
      </a>
    </div>
  );
}; 

export default Opportunities;
